import React from 'react';

interface PickUpInfoItemProps {
    label: string;
    value: string;
}

// 派送页面 订单详情统一样式
const PickUpInfoItem: React.FC<PickUpInfoItemProps> = ({label, value}) => {
    return (
        <div className="flex justify-between gap-3 py-2 border-gray-100">
            <span className="text-gray-600 text-sm whitespace-nowrap shrink-0">{label}:</span>
            <span className="text-sm font-medium text-right break-all">{value}</span>
        </div>
    );
};

export default PickUpInfoItem;
